import { getVerifyOTP, resetVerifyOTP, verifyOTP } from 'modules/user/actions'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './index.scss'
const ReactOTPInput = props => {
    const { numOfInputs, setOtp } = props
    const OTP_LENGTH = new Array(numOfInputs).fill(0)
    const [value, setValue] = useState('')
    const [focused, setFocused] = useState(false)
    const values = value.split('')
    const inputRef = useRef()
    const selectedIndex = values.length < OTP_LENGTH.length ? values.length : OTP_LENGTH.length - 1
    const hideInput = !(values.length < OTP_LENGTH.length)

    const onInputClick = () => {
        inputRef.current.focus()
    }
    const handleFocus = () => {
        setFocused(true)
    }
    const handleBlur = () => {
        setFocused(false)
    }

    const [state_verifyingOTP, setVerifyingOTP] = useState(true)

    if (value.length == 6 && state_verifyingOTP) {
        const request = {}
        const code = value
        request.code = code
        setVerifyingOTP(false)
    }

    const handleChange = e => {
        if (value.length >= OTP_LENGTH.length) return null
        if (!/^\d*$/.test(e.target.value)) return
        const val = value + e.target.value
        setValue(val)
        setOtp(val)
    }

    const handleKeyUp = e => {
        if (e.key === 'Backspace') {
            const val = value.slice(0, value.length - 1)
            setValue(val)
            setOtp(val)
        }
    }

    return (
        <div className="wrap" onClick={onInputClick}>
            <input
                value=""
                ref={inputRef}
                onChange={e => handleChange(e)}
                onKeyUp={e => handleKeyUp(e)}
                onFocus={handleFocus}
                onBlur={handleBlur}
                className="input"
                style={{
                    width: '32px',
                    top: '0px',
                    bottom: '0px',
                    left: `${selectedIndex * 32}px`,
                    opacity: hideInput ? 0 : 1,
                }}
                type="tel"
            />
            {OTP_LENGTH.map((v, index) => {
                const selected = values.length === index
                const filled =
                    values.length === OTP_LENGTH.length && index === OTP_LENGTH.length - 1

                return (
                    <div className="display">
                        {values[index]}
                        {(selected || filled) && focused && <div className="shadows" />}
                    </div>
                )
            })}
        </div>
    )
}

export default ReactOTPInput
